import { apiBaseSlices } from "./baseAPI";

export const userDetailSlices = apiBaseSlices.injectEndpoints({
    endpoints: (builder) => ({
        getUserDetail: builder.mutation({
            query: ({ userId, token }) => ({
                url: `users/${userId}/detail`,
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }),
        }),

        adjustCredit: builder.mutation({
            query: ({ userId, payload, token }) => ({
                url: `users/${userId}/adjust-credit`,
                method: "POST",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: payload,
            }),
        }),
    }),
});

export const { useGetUserDetailMutation, useAdjustCreditMutation } = userDetailSlices;
